import { render, staticRenderFns } from "./OpticLensSetup.vue?vue&type=template&id=5a4730e6&scoped=true"
import script from "./OpticLensSetup.vue?vue&type=script&lang=js"
export * from "./OpticLensSetup.vue?vue&type=script&lang=js"
import style0 from "./OpticLensSetup.vue?vue&type=style&index=0&id=5a4730e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a4730e6",
  null
  
)

export default component.exports